<template>
  <div>
  <Breadcrumbs main="Request" title="Token Request" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 pr-sm-0 box-col-12">
          <div class="file-sidebar">
            <div class="card">
              <div class="card-body">
                <ul>
                <li>
                <router-link to="/requestManagement/token">
                    <div class="btn btn-primary">
                      <feather type="toggle-right"></feather>
                      Hard Token Request
                    </div>
                    </router-link>
                  </li>
                  <li>
                  <router-link to="/requestManagement/cheque">
                    <div class="btn btn-light">
                      <feather type="book"></feather>
                      Cheque Request
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/requestManagement/form-A">
                    <div class="btn btn-light">
                      <feather type="pocket"></feather>
                      Form A
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/requestManagement/card">
                    <div class="btn btn-light">
                      <feather type="folder"></feather>
                      Card Management
                    </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
            <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>New Request</h5>
                <span>Initiate a new Hardware Token Request.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                      <section>
                          <!-- Initiate the Transfer -->
                          <div id="InitiateTransfer" v-show="step === 1">
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="AccountNumber">Source Account <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-select acct-num" data-val-length="The field AccountNumber must be a string with a maximum length of 250." data-val-length-max="250" data-val-required="The AccountNumber field is required." id="AccountNumber" name="AccountNumber" required="required"><option value="" disabled>Select From Account *</option>
                                        <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="location">Current Location <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select @change="getCurrentLocation" v-model="form.currentLocationId" class="form-select acct-num" required="required"><option value="" disabled>Select To Current Location *</option>
                                      <option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="DeliveryOption">Delivery Option <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.deliveryOption" required="required"><option value="">Select Delivery Option *</option>
                                      <option v-for="options in deliveryOptions" :value="options.id" :key="options.id">{{options.description}}</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row animated fadeIn" v-if="form.deliveryOption == 1 || form.deliveryOption == 3">
                                  <label class="col-sm-3 col-form-label" for="DeliveryOption">Pickup Branch <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.branchId" required="required"><option value="">Select Pickup Branch *</option>
                                      <option v-for="location in locationBranches" :value="location.id" :key="location.id">{{location.name}}</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="mb-3 row animated fadeIn" v-if="form.deliveryOption == 3">
                                    <label class="col-sm-3 col-form-label">Third-Party Name For Pickup <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.thirdPartyName" placeholder="Enter Third-Party Name" type="text" value="" />
                                    </div>
                                </div>
                                <div class="mb-3 row animated fadeIn" v-if="form.deliveryOption == 3">
                                  <label class="col-sm-3 col-form-label" for="DeliveryOption">Third-Party Means Of Identification <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.thirdPartyMeansOfId" required="required"><option value="" disabled>Select Means Of Identification for Third-Party *</option>
                                      <option v-for="id in idTypes" :value="id.id" :key="id.id">{{id.description}}</option>
                                      </select>
                                  </div>
                              </div>
                              <section class="delivery-section animated fadeIn" v-if="form.deliveryOption == 2">
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="address1">Delivery Address Line 1 <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.deliveryAddressLine1" name="address1" placeholder="Enter Delivery Address Line 1" type="text" value="" maxlength="60" />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="address2">Delivery Address Line 2</label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.deliveryAddressLine2" name="address2" placeholder="Enter Delivery Address Line 2" type="text" value="" maxlength="60" />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="addresscity">Delivery City <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.deliveryAddressCity" name="addresscity" placeholder="Enter Delivery City" type="text" value="" maxlength="60"/>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="DeliveryOption">Delivery State <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <select class="form-select acct-num" v-model="form.deliveryStateId" required="required"><option value="" disabled>Select Delivery State  *</option>
                                        <option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
                                        </select>
                                    </div>
                                </div>
                              </section>
                              <div class="row mt-4">
                                  <div class="col-sm-12 offset-lg-3 offset-sm-0">
                                      <button type="button" @click="validate" class="btn btn-round btn-primary mr-1">
                                      <div v-if="loading">
                                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Verifying Transaction...
                                      </div>
                                      <div v-else>
                                        Proceed<i class="fa fa-angle-right ml-2"></i>
                                      </div>
                                      </button>
                                      <button type="button" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                                  </div>
                              </div>
                          </div>
                          <!-- card cost -->
                          <section v-show="step === 2">
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="BranchId">Cost Breakdown</label>
                                <div class="col-sm-9 col-xl-7">
                                    <div class="table-responsive-sm">
                                        <table class="table table-striped" width="100%">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Item</th>
                                                    <th>Unit Cost</th>
                                                    <th>Vat</th>
                                                    <th>Line Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Token</td>
                                                    <td id="unit-cost">₦{{requestFee.feeAmount}}</td>
                                                    <td id="quantity">₦{{requestFee.vat}}</td>
                                                    <td id="line-total">₦{{requestFee.total}}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2"></td>
                                                    <td>Total</td>
                                                    <td id="total-cost" class="text-success">₦{{requestFee.total}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <br />
                              <div class="mb-3 row">
                                  <div class="col-sm-9  offset-lg-3 offset-sm-0">
                                  <input style="background-color: red;" type="checkbox" name="checkbox" v-model="checked" value="check" id="agree" /> I have read and agree to the <a href="https://digitaltest.tajbank.com/files/Token_T&C.pdf" target="_blank" class="primary-color">Terms and Conditions</a> &nbsp;<br /><br />
                                      <button type="button" @click="checkedTerms" class="btn btn-primary mr-2">
                                        <div v-if="loading">
                                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                        </div>
                                        <div v-else>
                                          Proceed <i class="fa fa-angle-right ml-2"></i>
                                        </div>
                                      </button>
                                      <button type="button" class="btn btn-outline-danger" @click="goBackTo">Go Back</button>
                                  </div>
                              </div>
                          </section>
                          <!-- Verify Account Name and Submit Transfer Request -->
                          <div id="AccountNameVerification" v-show="step === 3">
                              <div class="mb-4 row">
                                  <label class="col-sm-3 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.securityQuestionId" required="required"><option value="" disabled>Select Security Question  *</option>
                                        <option v-for="question in userSecurityQuestion" :value="question.id" :key="question.id">{{question.question}}</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input class="form-control" v-model="form.securityAnswer" id="SecurityAnswer" maxlength="250" name="SecurityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                                      <span @click="showAnswer" class="pull-right show-pin">{{ answerType === 'password' ? 'show': 'hide'}}</span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                                      <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Token" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <br />
                              <div class="mb-3 row">
                                  <div class="col-sm-9 offset-lg-3 offset-sm-0">
                                      <button type="button" class="btn btn-primary mr-2" @click="initiateTokenRequest">
                                        <div v-if="loading">
                                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                        </div>
                                        <div v-else>
                                          Submit <i class="fa fa-check ms-2"></i>
                                        </div>
                                      </button>
                                      <button type="button" class="btn btn-outline-danger" @click="goBackTo">Go Back</button>
                                  </div>
                              </div>
                          </div>
                      </section>
                  </div>
              </div>

              <!-- Request Success Response -->
              <div id="RequestSuccessResponseSection" v-show="step === 4" class="animated fadeIn" style="display:block">
                <div class="card-body">
                    <div class="align-content-center align-items-center justify-content-center p-2 text-center">
                        <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                        <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> REQUEST SUCCESSFUL!</h5>
                        <p>Your request has been submitted successfully!</p>
                        <router-link to="/dashboard/default">
                            <a class="btn btn-primary btn-round">Go To Home<i class="fa fa-home ml-2"></i></a>
                        </router-link>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import { decrypt } from '../../_services/encryption';
  export default {
    data:() => ({
      form: {
        accountNumber: '',
        nameOnCard: '',
        currentLocationId: '',
        cardType: '',
        deliveryOption: '',
        deliveryStateId: '',
        thirdPartyMeansOfId: '',
        deliveryAddressCity: '',
        deliveryAddressLine1: '',
        deliveryAddressLine2: '',
        branchId: '',
        thirdPartyName: '',
        securityQuestionId: '',
        securityAnswer: '',
        transactionPin: '',
        platform: 1,
      },
      step: 1,
      checked: false,
      loading: false,
      type: 'password',
      answerType: 'password',
      isSecurityQuestion: localStorage.getItem('isSecurityQuestion'),
    }),
    computed: {
      ...mapState({
        states: state => state.authentication.states,
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        cardTypes: state => state.requests.cardTypes,
        allBranches: state => state.requests.allBranches,
        locationBranches: state => state.requests.locationBranches,
        idTypes: state => state.authentication.idTypes,
        deliveryOptions: state => state.requests.deliveryOptions,
        userSecurityQuestion: state => state.authentication.userSecurityQuestion,
        userDetails: state => state.dashboard.dashboardData.customerDetails.userName,
        requestFee: state => state.requests.requestFee,
      }),
    },
    async mounted() {
      await this.$store.dispatch('getStates');
      await this.$store.dispatch('requests/getCardTypes');
      await this.$store.dispatch('getIdTypes');
      await this.$store.dispatch('requests/getAllBranches');
      await this.$store.dispatch('requests/getDeliveryOptions');
      await this.$store.dispatch('getUserSecurityQuestion', { username: this.userDetails, customerType: 2 });
      await this.$store.dispatch('requests/getRequestFee', 1);
      if(this.isSecurityQuestion === 'true') {
        this.$router.push('/settings/reset-security-question');
      }
    },
    methods : {
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          
          event.returnValue = false;
        }
      },
      checkedTerms() {
        if (this.checked === true) {
          this.step = 3;
        } else {
          this.$swal({
            title: 'Oops...',
            text: 'Please accept the terms and conditions',
            type: 'error',
            confirmButtonText: 'Ok'
          });
        }
      },
      // show pin
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      showAnswer() {
        this.answerType = this.answerType === 'password' ? 'text' : 'password';
      },
      goNext() {
        this.step++;
      },
      getCurrentLocation(event) {
        const locationId = event.target.value;
        this.$store.dispatch('requests/getLocationBranches', locationId).then(() => {
        }).catch(error => {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok'
          });
        });
      },
      validate() {
        const { accountNumber, currentLocationId , deliveryOption, branchId, deliveryAddressLine1, deliveryAddressCity, deliveryStateId, thirdPartyMeansOfId, thirdPartyName } = this.form;
        if(accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill all the required fields',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
        if (deliveryOption === 1) {
          if (branchId === '' || accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all required fields',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return false;
          } else {
            this.form.deliveryAddressLine1 = '';
            this.form.deliveryAddressLine2 = '';
            this.form.deliveryAddressCity = '';
            this.form.deliveryStateId = '';
            this.form.thirdPartyMeansOfId = '';
            this.form.thirdPartyName = '';
            this.step = 2;
          }
        }
        // check if delivery option is 2 then check if address is filled
        if (deliveryOption === 2) {
          if (deliveryAddressLine1 === '' || deliveryAddressCity === '' || deliveryStateId === '' || accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all required fields',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return false;
          } else {
            this.form.branchId = '';
            this.form.thirdPartyMeansOfId = '';
            this.form.thirdPartyName = '';
            this.step = 2;
          }
        }
        // check if delivery option is 3 then check if third party detials are filled
        if (deliveryOption === 3) {
          if (thirdPartyMeansOfId === '' || thirdPartyName === '' || accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all required fields',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return false;
          } else {
            this.form.deliveryAddressLine1 = '';
            this.form.deliveryAddressLine2 = '';
            this.form.deliveryAddressCity = '';
            this.form.deliveryStateId = '';
            this.step = 2;
          }
        }
      },
      initiateTokenRequest() {
        const pickup = {
          accountNumber: this.form.accountNumber,
          currentLocationId: this.form.currentLocationId,
          deliveryOption: this.form.deliveryOption,
          branchId: this.form.branchId,
          securityQuestionId: this.form.securityQuestionId,
          securityAnswer: this.form.securityAnswer,
          transactionPin: this.form.transactionPin,
          platform: this.form.platform,
        };
        const delivery = {
          accountNumber: this.form.accountNumber,
          currentLocationId: this.form.currentLocationId,
          deliveryOption: this.form.deliveryOption,
          deliveryAddressLine1: this.form.deliveryAddressLine1,
          deliveryAddressLine2: this.form.deliveryAddressLine2,
          deliveryAddressCity: this.form.deliveryAddressCity,
          deliveryStateId: this.form.deliveryStateId,
          securityQuestionId: this.form.securityQuestionId,
          securityAnswer: this.form.securityAnswer,
          transactionPin: this.form.transactionPin,
          platform: this.form.platform,
        };
        const thirdParty = {
          accountNumber: this.form.accountNumber,
          currentLocationId: this.form.currentLocationId,
          branchId: this.form.branchId,
          deliveryOption: this.form.deliveryOption,
          thirdPartyMeansOfId: parseInt(this.form.thirdPartyMeansOfId),
          thirdPartyName: this.form.thirdPartyName,
          securityQuestionId: this.form.securityQuestionId,
          securityAnswer: this.form.securityAnswer,
          transactionPin: this.form.transactionPin,
          platform: this.form.platform,
        };
        const checkDeliveryOption = this.form.deliveryOption === 1 ? pickup : this.form.deliveryOption === 2 ? delivery : thirdParty;
        // check if all fields are filled
        if(this.form.securityQuestionId === '' || this.form.securityAnswer === '' || this.form.transactionPin === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill all required fields',
            type: 'error',
            confirmButtonText: 'Ok',
          });
          return false;
        } else {
          this.loading = true;
          this.$store.dispatch('requests/tokenRequest', checkDeliveryOption).then(() => {
            this.loading = false;
            this.step = 4;
          }).catch(error => {
            this.loading = false;
            // sweet alert
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok',
            });
          });
        }
      },
      goBackTo() {
        this.step--;
      },
      resetForm() {
        this.form = {
          accountNumber: '',
          nameOnCard: '',
          currentLocationId: '',
          cardType: '',
          deliveryOption: '',
          branchId: '',
          deliveryAddressLine1: '',
          deliveryAddressLine2: '',
          deliveryAddressCity: '',
          deliveryStateId: '',
          thirdPartyMeansOfId: '',
          thirdPartyName: '',
          securityQuestionId: '',
          securityAnswer: '',
          transactionPin: '',
        };
      },
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
</style>